import { maLookback } from '../../math/ma'
import { COLOR, line, matype, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'MA',
  version: 2,
  label: 'Moving Average',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 10,
  inputs: [period('timeperiod', 30), matype()],
  outputs: [line('ma', 'MA', COLOR.blue)],
  talib: { functions: ['MA'], expr: 'MA(close, timeperiod={timeperiod}, matype={matype})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod, matype }) => maLookback(timeperiod, matype),
}
export default def
